import axios from 'axios';
import { API_URL } from '../config';

const base = `${API_URL}/admin`;

export async function fetchAdminPlans() {
  const { data } = await axios.get(`${base}/plans`);
  return data.plans || [];
}

export async function fetchAdminPlan(planSlug) {
  const { data } = await axios.get(`${base}/plans/${planSlug}`);
  return data;
}

export async function patchAdminPlan(planSlug, payload) {
  const { data } = await axios.patch(`${base}/plans/${planSlug}`, payload);
  return data;
}

export async function fetchPlanSubscribers(planSlug) {
  const { data } = await axios.get(`${base}/plans/${planSlug}/subscribers`);
  return data.subscribers || [];
}

export async function notifyPlanPriceChange(planSlug, body) {
  const { data } = await axios.post(`${base}/plans/${planSlug}/notify-price-change`, body);
  return data;
}

export async function patchAdminPlanFeatures(planSlug, features) {
  const { data } = await axios.patch(`${base}/plans/${planSlug}/features`, { features });
  return data;
}

export async function fetchAdminAddons() {
  const { data } = await axios.get(`${base}/addons`);
  return data.addons || [];
}

export async function createAdminAddon(payload) {
  const { data } = await axios.post(`${base}/addons`, payload);
  return data;
}

export async function patchAdminAddon(addonId, payload) {
  const { data } = await axios.patch(`${base}/addons/${addonId}`, payload);
  return data;
}

export async function fetchEnterpriseConfigs() {
  const { data } = await axios.get(`${base}/enterprise-configs`);
  return data.configs || [];
}

export async function createEnterpriseConfig(payload) {
  const { data } = await axios.post(`${base}/enterprise-configs`, payload);
  return data;
}

export async function patchEnterpriseConfig(companyId, payload) {
  const { data } = await axios.patch(`${base}/enterprise-configs/${companyId}`, payload);
  return data;
}

export async function deleteEnterpriseConfig(companyId) {
  const { data } = await axios.delete(`${base}/enterprise-configs/${companyId}`);
  return data;
}

export async function fetchSystemSettings() {
  const { data } = await axios.get(`${base}/system-settings`);
  return data;
}

export async function patchSystemSettings(payload) {
  const { data } = await axios.patch(`${base}/system-settings`, payload);
  return data;
}

export async function fetchCatalogPreview() {
  const { data } = await axios.get(`${base}/catalog/preview`);
  return data;
}

export function centsToDisplay(cents) {
  if (cents == null || cents === '') return '';
  return (Number(cents) / 100).toFixed(2);
}

export function displayToCents(value) {
  const n = parseFloat(String(value).replace(/[^0-9.]/g, ''));
  if (Number.isNaN(n)) return 0;
  return Math.round(n * 100);
}

export function yearlySavingsPercent(monthlyCents, yearlyCents) {
  const mo = Number(monthlyCents) || 0;
  const yr = Number(yearlyCents) || 0;
  if (mo <= 0 || yr <= 0) return 0;
  const annualAtMonthly = mo * 12;
  if (yr >= annualAtMonthly) return 0;
  return Math.round((1 - yr / annualAtMonthly) * 100);
}

export function yearlyMonthlyEquivalent(yearlyCents) {
  const yr = Number(yearlyCents) || 0;
  if (yr <= 0) return 0;
  return Math.round(yr / 12);
}

export const PLAN_SLUG_LABELS = {
  growing: 'Growing',
  scaling: 'Scaling',
  enterprise: 'Enterprise',
};

export const ALL_PLAN_SLUGS = ['growing', 'scaling', 'enterprise'];

export function isPriceChangeConfirmationError(err) {
  const d = err?.response?.data?.detail;
  return err?.response?.status === 409 && d?.code === 'PRICE_CHANGE_CONFIRMATION_REQUIRED';
}

export function priceChangeDetail(err) {
  return err?.response?.data?.detail || null;
}
